import { render, staticRenderFns } from "./DashboardCustomerList.vue?vue&type=template&id=577cf9fb&"
import script from "./DashboardCustomerList.vue?vue&type=script&lang=ts&"
export * from "./DashboardCustomerList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports